<template>
  <div>
    <div class="subtitle" v-if="achievements.length">Achievementi</div>
    <span class="achievements-fulfilled" v-if="achievements.length">
      Broj ostvarenih achievementa:
      <span class="achievements-fulfilled-count">{{ userAchievementIds.length }}/{{ achievements.length }}</span>
    </span>
    <div class="achievements-wrapper">
      <Slider v-if="!isMobile && achievements.length > 0" autoSlidingDisabled="true" :key="sliderRenderCount">
        <div
          v-bind:class="[
            'achievement-box slider-item',
            userAchievementIds.indexOf(achievement.id) !== -1 ? 'fulfilled' : 'not-fulfilled',
          ]"
          v-for="achievement in achievements"
          v-bind:key="achievement.id"
        >
          <div class="achievement-icon-points-wrapper">
            <img draggable="false" class="unlocked-icon" v-bind:src="getAchievementUnlockedIcon(achievement.name)" />
            <img draggable="false" class="locked-icon" v-bind:src="getAchievementLockedIcon(achievement.name)" />
            <div class="achievement-points-wrapper">
              <img draggable="false" class="achievement-star" src="../../../assets/app-icons/achievements/star.svg" />
              <img
                draggable="false"
                class="achievement-star-locked"
                src="../../../assets/app-icons/achievements/star-locked.svg"
              />
              <span class="achievement-points">{{ achievement.points }}</span>
            </div>
          </div>

          <div class="achievement-name">{{ achievement.name }}</div>
          <div class="achievement-description">
            {{ achievement.description }}
          </div>
        </div>
      </Slider>
      <div v-else-if="isMobile && achievements.length > 0" class="scrollable-slider">
        <div
          v-bind:class="[
            'achievement-box slider-item',
            userAchievementIds.indexOf(achievement.id) !== -1 ? 'fulfilled' : 'not-fulfilled',
          ]"
          v-for="achievement in achievements"
          v-bind:key="achievement.id"
        >
          <div class="achievement-icon-points-wrapper">
            <img draggable="false" class="unlocked-icon" v-bind:src="getAchievementUnlockedIcon(achievement.name)" />
            <img draggable="false" class="locked-icon" v-bind:src="getAchievementLockedIcon(achievement.name)" />
            <div class="achievement-points-wrapper">
              <img draggable="false" class="achievement-star" src="../../../assets/app-icons/achievements/star.svg" />
              <img
                draggable="false"
                class="achievement-star-locked"
                src="../../../assets/app-icons/achievements/star-locked.svg"
              />
              <span class="achievement-points">{{ achievement.points }}</span>
            </div>
          </div>

          <div class="achievement-name">{{ achievement.name }}</div>
          <div class="achievement-description">
            {{ achievement.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deviceHandling } from '@/mixins.js';

import Slider from '@/components/app/Slider.vue';

export default {
  name: 'Achievements',
  mixins: [deviceHandling],
  components: { Slider },
  props: {
    achievementIdsToAdd: Array,
  },
  data() {
    return {
      achievements: [],
      currentAchievementIds: [],
      sliderRenderCount: 0,
    };
  },
  computed: {
    userAchievementIds: function() {
      return [...this.currentAchievementIds, ...this.achievementIdsToAdd];
    },
  },
  methods: {
    getAchievementUnlockedIcon: function(achievementName) {
      // eslint-disable-next-line
      return require(`../../../assets/app-icons/achievements/${achievementName
        .replace(/\s/g, '')
        .replace(/!/g, '')
        .replace(/\?/g, '')
        .replace(/\./g, '')
        .toLowerCase()}.svg`);
    },
    getAchievementLockedIcon: function(achievementName) {
      // eslint-disable-next-line
      return require(`../../../assets/app-icons/achievements/${achievementName
        .replace(/\s/g, '')
        .replace(/!/g, '')
        .replace(/\?/g, '')
        .replace(/\./g, '')
        .toLowerCase()}-locked.svg`);
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/achievements/all-achievements`).then(response => {
      this.achievements = response.data;
    });
    this.$axios.get(`${this.$API_URL}/user/fulfilled-achievement-ids`).then(response => {
      this.currentAchievementIds = response.data;
    });

    window.addEventListener('resize', () => this.sliderRenderCount++);
  },
};
</script>

<style scoped>
.scrollable-slider {
  display: flex;
  overflow: auto;
  padding-left: 24px;
}

.more-info-title {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  color: #7a8e94;
}

.subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
  margin-bottom: 8px;
}
.achievements-fulfilled {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.achievements-fulfilled-count {
  font-weight: bold;
}
.achievements-wrapper {
  margin: 42px -115px 15px -115px;
}
.achievements-wrapper .slider {
  padding: 25px 115px 150px 115px;
  margin-top: -25px;
  width: 100vw;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.achievements-wrapper .achievement-icon-points-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.achievements-wrapper .achievement-box {
  min-width: 285px;
  height: 195px;
  padding: 23px 23px 50px 23px;
  margin: 0 0 0 30px;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.05);
  box-sizing: border-box;
  position: relative;
  user-select: none;
}
.achievements-wrapper .achievement-box:first-of-type {
  margin: 0;
}
.achievements-wrapper .achievement-box:last-of-type::after {
  content: '';
  display: block;
  position: absolute;
  right: -150px;
  width: 150px;
  height: 1px;
}

.achievements-wrapper .achievement-box.not-fulfilled img.achievement-star {
  display: none;
}

.achievements-wrapper .achievement-box.fulfilled img.achievement-star-locked {
  display: none;
}
.achievements-wrapper .achievement-box img.fulfilled-mark {
  height: 15px;
}
.achievements-wrapper .achievement-box img.achievement-star,
.achievements-wrapper .achievement-box img.achievement-star-locked {
  width: 21px;
  height: 21px;
  vertical-align: middle;
}
.achievements-wrapper .achievement-box .achievement-points {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
}
.achievements-wrapper .achievement-box .achievement-name {
  font-family: 'Fuse V.2 Display';
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  margin-bottom: 5px;
  color: #fff;
  white-space: normal;
}

.achievements-wrapper .achievement-box.not-fulfilled .achievement-name {
  color: #d9e0e5;
}

.achievements-wrapper .achievement-box .achievement-points-wrapper {
  display: flex;
  align-items: center;
}

.achievements-wrapper .achievement-box .achievement-description {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}

.achievements-wrapper .achievement-box .achievement-points-wrapper img {
  margin-right: 5px;
}
.achievements-wrapper .achievement-box .fulfilled-mark {
  display: none;
}

.achievements-wrapper .achievement-box.fulfilled .fulfilled-mark {
  display: block;
}
.achievements-wrapper .achievement-box img.unlocked-icon,
.achievements-wrapper .achievement-box img.locked-icon {
  height: 35px;
  width: 35px;
  margin-right: auto;
  display: none;
}

.achievements-wrapper .achievement-box.not-fulfilled img.locked-icon {
  display: block;
}

.achievements-wrapper .achievement-box.fulfilled img.unlocked-icon {
  display: block;
}

@media screen and (max-width: 1096px) {
  .achievements-wrapper {
    margin: 42px -25px 0 -25px;
  }
  .achievements-wrapper .slider {
    padding: 25px 25px 150px 25px;
  }
  .achievements-wrapper .achievement-box:last-of-type::after {
    right: -25px;
    width: 25px;
  }
}

@media screen and (max-width: 550px) {
  .achievements-wrapper {
    margin-top: 14px;
  }
  .achievements-wrapper .slider {
    padding-bottom: 50px;
  }
  .achievements-wrapper .achievement-box {
    min-width: 214px;
    height: 158px;
    padding: 19px 16px 44px 16px;
    margin-left: 14px;
  }

  .achievements-wrapper .achievement-box .achievement-name {
    margin-bottom: 2px;
    font-size: 16px;
    line-height: 19px;
  }
}
</style>
